import { Calendar } from "lucide-react";

export default function Blog() {
  const articles = [
    {
      title: "New Research For Green Life",
      date: "01 JAN 2045",
      image:
        "https://images.pexels.com/photos/414837/pexels-photo-414837.jpeg?auto=compress&cs=tinysrgb&w=800",
    },
    {
      title: "Happy City After Energized",
      date: "01 JAN 2045",
      image:
        "https://images.pexels.com/photos/414807/pexels-photo-414807.jpeg?auto=compress&cs=tinysrgb&w=800",
    },
    {
      title: "Turbines Helped Alot For People",
      date: "01 JAN 2045",
      image:
        "https://images.pexels.com/photos/532192/pexels-photo-532192.jpeg?auto=compress&cs=tinysrgb&w=800",
    },
  ];

  return (
    <section
      id="pages"
      className="py-20 bg-gradient-to-b from-white to-orange-50/30"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="text-orange-500 text-sm font-semibold mb-3 tracking-wider">
            BLOG & ARTICLES
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900">
            Read Our Latest News
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {articles.map((article, index) => (
            <div
              key={index}
              className="group bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
            >
              <div className="relative h-64 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="p-6">
                <div className="flex items-center text-gray-500 text-sm mb-3">
                  <Calendar size={16} className="mr-2" />
                  {article.date}
                </div>
                <h3 className="text-xl font-bold text-gray-900 group-hover:text-orange-500 transition-colors">
                  {article.title}
                </h3>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <button className="px-8 py-4 bg-orange-500 text-white rounded-full font-medium hover:bg-orange-600 transition-all duration-300 hover:shadow-xl hover:scale-105">
            Read More
          </button>
        </div>
      </div>
    </section>
  );
}
